import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/f55fa10b-011f-4fd6-bae7-ebc3e35874f3";
export const REGISTER_URL = "https://a.ntrk2.com/e48ddbb1-4a54-4401-9ecd-252df68e48e9";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://phwow.kzw2a.com/download?openExternalBrowser=1&id=a444ipy1hmtg5r7";
